import { GSPBusinessEntity } from '@gsp-bef/gsp-be-metadata';
import { GSPViewModel } from '@gsp-bef/gsp-vo-metadata';
import { CommonModelUtil } from '@gsp-bef/gsp-cm-metadata';
import { VOTemplateType } from '../entity/VOTemplateType';

export class CommonModelTypeHelper {
    public static getCommonModelType(cm: GSPBusinessEntity | GSPViewModel): string {
        let type = CommonModelUtil.GetGeneratedConfigID(cm as any);
        type = "com." + type;
        return type;
    }

    /**
     * 判断VO来源于BE还是VO或者完全虚拟
     * @param gspViewModel
     */
    public static judgeVoTemplateType(gspViewModel: GSPViewModel): VOTemplateType {
        if (gspViewModel.IsVirtual === true) {
            if (gspViewModel.TemplateVoInfo && gspViewModel.TemplateVoInfo.TemplateVoId != null) {
                return VOTemplateType.FromVO;
            } else {
                return VOTemplateType.FromNone
            }
        } else {
            return VOTemplateType.FromBE;
        }
    }
}
